export function getPublications(state: any) {
    return state.publication.rows;
}

export function getPublicationsMeta(state: any) {
    return state.publication.meta;
}

export function hasMorePublications(state: any) {
    const rows = getPublications(state);
    const meta = getPublicationsMeta(state);

    return meta.totalSize > rows.length;
}

export function isLoading(state: any) {
    return state.publication.isLoading;
}
export function getPageParams(state: any) {
    return state.publication.params;
}

export function getPublicationsByResearcherPage(state: any) {
    return state.publication.listByResearchers || {};
}

export function getPublication(state: any) {
    return state.publication.one;
}

export function getPublicationYears(state: any) {
    return state.publication.years;
}

export function isLoadingYears(state: any) {
    return state.publication.isLoadingYears;
}
